import { render, staticRenderFns } from "./MediaCallPage.vue?vue&type=template&id=c1529f96&"
import script from "./MediaCallPage.vue?vue&type=script&lang=js&"
export * from "./MediaCallPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1529f96')) {
      api.createRecord('c1529f96', component.options)
    } else {
      api.reload('c1529f96', component.options)
    }
    module.hot.accept("./MediaCallPage.vue?vue&type=template&id=c1529f96&", function () {
      api.rerender('c1529f96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/MediaCallPage.vue"
export default component.exports